<script>
import formGroupInputVue from "../../vendors/vue-nud-pro-html-v1.0.0/src/components/Inputs/formGroupInput.vue";

export default {
  extends: formGroupInputVue,
  name: "BaseInput",
};
</script>
